import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AdminUser } from './../../../node_modules/@reflact/ipkv-types/dist/Admin.d';
import { Auth } from './auth';

@Injectable({
  providedIn: 'root'
})
export class Login {
  public http = inject(HttpClient);
  public auth = inject(Auth);
  public router = inject(Router);

  public email = signal("");
  public pin = signal("");

  public async loginWithEmail(email: string) {
    this.email.set(email);
    await firstValueFrom(this.http.post("/api/login/email", { email }));
  }

  public async validateFactor2(pin: string) {
    if (!this.email()) {
      throw new Error("No Email found!");
    }
    this.pin.set(pin);
    try {
      const res = await firstValueFrom(this.http.post<{ token: string, user: AdminUser }>("/api/login/factor2", { email: this.email(), pin }));
      this.auth.setUserTokenAfterAuth(res.token, res.user);
      this.router.navigate(["/"]);
    } catch (e) {
      throw new Error("Invalid login");
    }
  }

}
